import React from 'react';

import component from './component';
import Link from './Link'
import Nav from './Nav';
import TopBanner from './TopBanner';

import {KBLogo} from './icons';

export default component('Footer', function({data}) {

  return (
    <div className='Footer'>
      <div className='Footer-NoBackgroundBefore' style={{
        backgroundImage: `url(${require('../img/headerBgLow.jpg')})`
      }}></div>
      <div className='Footer-OverlayBottom'>
        <div className='Footer-OverlayTop'>
          <div className='Footer-Content'>

            <div className='Footer-Menu'>
              <Nav bottom={true}
                   route={data.cursor('route')}
                   data={data.cursor('nav')} />
            </div>

            <div className='Footer-Divider'>
              <div className='Footer-Circle'></div>
            </div>

            <div className='Footer-Disclaimer'>
              © 2021, ООО «Иннова Дистрибьюшен»<br />
              <a href="https://ru.4game.com/legal/4game/" target="_blank">Юридические документы</a><br />
              <a href="https://ru.4game.com/legal/4game/16/" target="_blank">Политика конфиденциальности</a>
            </div>
            <div className='Footer-KindBeetle'>
              <a href="http://kindbeetle.ru/" target="_blank">
                <KBLogo/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/Footer.js